export const environment = {
    production: true, 
    url: "https://dev-backend.plataformatmh.com/api/",
    url_page: "https://dev-backend.plataformatmh.com",
    apiUrl: "https://dev-backend.plataformatmh.com/api",
    host_socket: "dev-backend.plataformatmh.com",
    port_socket: 443,
    key_socket: "logist-key",
    cluster_socket: "mt1",
    forceTLS: true
};
